import { render } from "./LogoutView.vue?vue&type=template&id=30eec2ec&scoped=true"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import "./LogoutView.vue?vue&type=style&index=0&id=30eec2ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30eec2ec"]])

export default __exports__